// extracted by mini-css-extract-plugin
module.exports = {"signup-container":"Signup_signup-container__2268B","signup-form":"Signup_signup-form__3FlDL","desc":"Signup_desc__3Y-Ws","route":"Signup_route__2zEv4"};